'use strict';

import React, { Component, Fragment } from 'react';
import * as qwest from 'qwest';
import is from 'is_js';
import TextEditor from 'Components/Forms/Elements/TextEditor';
import TextInput from 'Components/Forms/Elements/TextInput';
import FileInput from 'Components/Forms/Elements/FileInput';
import Switch from 'Components/Forms/Elements/Switch';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import Select from 'Components/Forms/Elements/Select';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getStateFromObject from 'Components/Forms/Functions/getStateFromObject';
import handleFileChange from 'Components/Forms/Functions/handleFileChange';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import getFormData from 'Components/Forms/Functions/getFormData';
import Loader from 'Pure/Loader';
import bemit from 'Functions/bemit';
import { action, URL } from 'Shared/Routes';
let app = window.app;
export default class NewsForm extends Component {
  state = {
    status_messages: {}
  };
  handleChange = handleChange.bind(this);
  handleFileChange = handleFileChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchNews();
    }
  }
  fetchNews = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/news/get-all', {
      id: props.id || window.location.pathname.slice(window.location.pathname.lastIndexOf('/') + 1),
      super_admin: window.location.pathname.startsWith('/super-admin'),
      with_count: false,
      show_past: true
    }).then(function (xhr, response) {
      let {
        images,
        ...news
      } = response.data[0] || {};
      images = images.map(image => ({
        ...image,
        status: 'uploaded'
      }));
      const update = getStateFromObject({
        data: news,
        model: 'news'
      });
      component.setState({
        ...update,
        'news[images]': images,
        '__files-news[images]': images,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const state_data = {
      ...state
    };
    let form_data = new FormData();
    const is__super_admin = window.location.pathname.startsWith('/super-admin');
    form_data.append('super_admin', is__super_admin);
    form_data = getFormData({
      form_data: form_data,
      state: state_data,
      pattern: 'news['
    });
    const url = props.type === 'update' ? action('updateNews') : action('createNews');
    qwest.post(url, form_data).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchNews();
      } else {
        component.clearForm();
        window.setTimeout(function () {
          app.navigateTo(URL(is__super_admin ? 'SuperAdminNewsDashboard' : 'AdminNewsDashboard'));
        }, 2000);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('news[')).reduce(function (update, key) {
      if (is.string(state[key])) {
        update[key] = '';
      } else if (is.array(state[key])) {
        update[key] = [];
      } else if (is.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState({
      ...update,
      '__files-news[images]': [],
      'news[images]': []
    });
  };
  editUrl = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let url = (value || '').split('/').map(function (chunk) {
      return chunk.split('-').join(' ');
    }).join('/');
    if (url.startsWith('/') === false) url = '/' + url;
    component.handleChange({
      e,
      value: url,
      name
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("form", {
      method: "POST",
      action: "/news/create",
      className: props.paper !== false ? 'c-paper' : undefined
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['news[title]'],
      name: "news[title]",
      label: "Titre",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 3
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['news[date]'],
      name: "news[date]",
      label: "Date",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 3
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['news[end_date]'],
      name: "news[end_date]",
      label: "Date de fin de validit\xE9",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/React.createElement(FileInput, {
      onChange: component.handleFileChange,
      data: state,
      multiple: true,
      name: "news[images]",
      label: "Image(s) d'illustration",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/React.createElement(TextEditor, {
      onChange: component.handleChange,
      value: state['news[content]'],
      name: "news[content]",
      label: "Contenu de l'actualit\xE9",
      status: state.status_messages
    }))), status), window.location.pathname.startsWith('/super-admin') ? getFormStatus({
      warning: 'Cette actualité sera publiée pour l\'établissement ' + (app.state.session?.user?._etablishment?.name || '') + '.'
    }) : undefined, /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20\r u-text-center"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.validate
    }, props.type === 'update' ? 'Enregistrer' : 'Créer cette actualité', loader)));
    return output;
  }
}
